module.exports = __webpack_public_path__ + "static/media/footer_bubble.36586a92.png";